import {Component} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {HostListener} from '@angular/core';
import {Input} from '@angular/core';
import {Output} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'ui-menu-item',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class UIMenuItemComponent {

    @Input()
    disabled: boolean;

    @Output()
    onSelectItem = new EventEmitter();

    @HostListener('click')
    selectItem() {
        if (this.disabled === undefined) {
            this.onSelectItem.emit();
        }
    }

}